<script>

  import { External, M } from '../external';
  import { onMount } from 'svelte';
  import Loader from '../Common/Loader.svelte';
  import { makeWebsiteRequest } from '../Common/tools';

  let loading = true;
  let invoices = [];

  let downloadInvoice = (invoice) => {
    window.location.href = '/me/download?type=invoice&data=' + invoice.id;
  };

  let recreateInvoice = async (invoice) => {
    let result = await makeWebsiteRequest({
      action: 'recreateInvoice',
      data: {
        id: invoice.id
      },
      method: 'post'
    });
    if (result.ok) {
      External.Tools.showAutohideMessage(2500, 'Invoice recreated successfully!');
    }
  };

  onMount(async () => {
    loading = true;
    let result = await makeWebsiteRequest({
      action: 'getInvoices'
    });
    if (result.ok) {
      invoices = result.data.filter(invoice => invoice.date);
    }
    loading = false;
  });
</script>
<div class="col20 flex align-center flex-col mt-25">
  <div class="w800">
    <h3 class="col20 f-left ta-left mb-15 roboto">{M.MY_INVOICES_TITLE}</h3>
    <span class="explain-text ta-left f-left col20 mb-25">{M.INVOICES_DESC}</span>
    <div class="f-left col20">
      <div class="section-bg messages-wrapper invoices-wrapper">
        {#if loading}
          <div class="col20 f-left" style="min-height: 100px">
            <Loader />
          </div>
        {:else}
          {#if invoices.length === 0}
            <div class="no-messages-wrapper">{M.NO_INVOICES_YET}</div>
          {:else}
            {#each invoices as invoice}
              <div class="message-item subscribtion-item transition-bg">
                <div class="top-part row flex flex-row align-center hover-parent">
                  <header class="flex-1">
                    <h4>
                      {External.Tools.dateToString(External.Tools.ddmmyyStringToDate(invoice.date), false)}
                      {#if invoice.accountType !== 'Trial'}
                        /{M.PLAN} {invoice.accountType} - {M['BILLING_TYPE_' + invoice.billingType]}/ -
                      {:else}
                        /{M['BILLING_TYPE_' + invoice.billingType]}/ -
                      {/if}
                      <b>
                        {#if invoice.amount < 0}
                          {M.REFUNDED}
                        {/if}
                        {External.WebPlatform.currencyWithCodeToStr(Math.abs(invoice.amount), invoice.currency, External.platformCountry)}
                      </b>
                    </h4>
                  </header>
                  <a class="material-icons-outlined flex-none button-tooltip hover-target" on:click={() => recreateInvoice(invoice)}
                     data-tooltip="Recreate Invoice" data-left="true">autorenew</a>
                  <a class="middle-button gray ml-15 flex-none" on:click={() => downloadInvoice(invoice)}>{M.DOWNLOAD_INVOICE}</a>
                </div>
              </div>
            {/each}
          {/if}
        {/if}
      </div>
    </div>
  </div>
</div>
